import { render, staticRenderFns } from "./addNewNote.vue?vue&type=template&id=5d307992&"
import script from "./addNewNote.vue?vue&type=script&lang=js&"
export * from "./addNewNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports